export default __webpack_public_path__ + "static/media/image11.10b5e9e0.svg";